import { Account } from "../accounts";
import { Asset } from "../asset";
import { MsgDeposit } from "./deposit";
import { Msg, RedactedContext } from "./msg";
import { MsgRedactedSwap } from "./private";

export class MsgSwap extends MsgDeposit implements Msg {
  constructor(
    account: Account,
    asset: Asset,
    amount: bigint,
    /** As retrieved from a ThorchainQuote response */
    private memo: string
  ) {
    super(account, asset, amount);
  }

  toMemo(): string {
    return this.memo;
  }

  toPrivate(ctx: RedactedContext): MsgRedactedSwap {
    return new MsgRedactedSwap(
      { address: ctx.publicAddress, network: "THOR" },
      ctx.stealth,
      this.amount.toString(),
      this.asset,
      this.memo
    );
  }
}
